<template>
    <div class="edit-personCenter">
            <MyTitle :theTitle="title"/>
            <div class="fd-com-scroll">
                <van-cell-group>
                    <van-field v-model="formData.userAttributeValueText" :right-icon="showEdit"
                               @click="showUserType = true"></van-field>
                    <van-popup v-if="isShow" v-model="showUserType" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="columns"
                                :default-index="0"
                                @cancel="showUserType = false"
                                @confirm="onUserTypeConfirm"
                        ></van-picker>
                    </van-popup>
                </van-cell-group>
            </div>
            <div class="fd-com-btn-container">
                <van-button
                    type="info"
                    plain
                    round
                    @click="saveUserInfo">
                    添加
                </van-button>
            </div>
    </div>
</template>

<script>
    import MyTitle from '../../components/common/myTitle';
    import {columnsRYLX, columnsGZDW, columnsMZ} from '../../utils/option'
    import {typeRylx, typeGzdwlx, typeMz} from '../../filters/index'
    import validate from '../../utils/validator/validator';
    import {
        userRule,
        XmRule,
        mzRule,
        ZjhmRule,
        EmailRule,
        zjlxRule,
        TxdzRule,
        QymcRule,
        dwxzRule,
        QyfrRule,
        TyshxydmRule
    } from '../../utils/validator/rules';

    export default {
        data() {
            return {
                userType: '',
                formData: {
                    userAttributeValue: '',
                    userAttributeValueText: '',
                    userAttributeName: '',
                    cUsertypeText: '',
                    cZjlxText: '',
                },
                postData: {
                    cUserid: '',
                    cUsertype: '',// 共有的 用户类型
                    cCardname: '',// 自然人 真实姓名
                    cMz: '',// 自然人 民族
                    cZjh: '',// 自然人 证件号
                    cEmail: '',// 共有的 邮箱
                    cGh: '',// 共有的 固定电话
                    cTxdz: '',// 自然人 的地址（经常居住地）
                    cDwmc: '',//非自然人 单位名称
                    cDwxz: '',//非自然人 单位性质
                    cQyfr: '',//非自然人 企业法人
                    cDwdz: ''//非自然人 通讯地址（单位地址）
                },
                title: '',
                isShow: false,
                showEdit: '',
                columns: [],
                showUserType: false,//是否显示用户类型弹出框
            }
        },
        created() {
            let userAttributeName = JSON.parse(sessionStorage.getItem("userAttributeName"));
            let userAttributeValue = JSON.parse(sessionStorage.getItem("userAttributeValue"));
            let userAttributeTitle = JSON.parse(sessionStorage.getItem("userAttributeTitle"));
            let isHideen = JSON.parse(sessionStorage.getItem("userAttributeShow"));
            let userType = JSON.parse(sessionStorage.getItem("userType"));
            this.userType = userType;
            this.formData.userAttributeName = userAttributeName;
            this.formData.userAttributeValue = userAttributeValue;
            this.formData.userAttributeValueText = userAttributeValue;
            if (isHideen) {
                this.showEdit = "arrow";
                this.isShow = true;
                this.handleLx(userAttributeName, userAttributeValue);
            }
            this.postData.cUserid = sessionStorage.getItem("userId")
            this.title = userAttributeTitle;
        },
        components: {
            MyTitle
        },
        methods: {
            saveUserInfo() {
                this.getData(this.formData.userAttributeName);
                const validateFormData = this.validateFormData();
                validateFormData.then(() => {
                    this.$axios.post('account/api/account/xcxedit', this.postData).then(res => {
                        if (res.code != 200) {
                            this.$notify(res.message);
                            return;
                        }
                        this.$notify({'type': 'success', 'message': '修改成功'});
                        history.go(-1);
                    }).catch(function () {
                        this.$notify("系统异常");
                    });
                })
            },
            getData(name) {
                switch (name) {
                    case "cCardname" :
                        this.postData.cCardname = this.formData.userAttributeValueText;
                        break;
                    case "cUsertype" :
                        this.postData.cUsertype = this.formData.userAttributeValue;
                        break;
                    case"cMz" :
                        this.postData.cMz = this.formData.userAttributeValue;
                        break;
                    case "cZjh" :
                        this.postData.cZjh = this.formData.userAttributeValueText;
                        break;
                    case "cEmail" :
                        this.postData.cEmail = this.formData.userAttributeValueText;
                        break;
                    case "cGh" :
                        this.postData.cGh = this.formData.userAttributeValueText;
                        break;
                    case "cTxdz" :
                        this.postData.cTxdz = this.formData.userAttributeValueText;
                        break;
                    case "cDwmc" :
                        this.postData.cDwmc = this.formData.userAttributeValueText;
                        break;
                    case "cDwxz" :
                        this.postData.cDwxz = this.formData.userAttributeValue;
                        break;
                    case "cQyfr" :
                        this.postData.cQyfr = this.formData.userAttributeValueText;
                        break;
                    case "cDwdz" :
                        this.postData.cDwdz = this.formData.userAttributeValueText;
                        break;
                }
            },
            handleLx(name, value) {
                switch (name) {
                    case "cUsertype" :
                        this.columns = columnsRYLX;
                        this.formData.userAttributeValueText = typeRylx(value);
                        break;
                    case"cDwxz" :
                        this.columns = columnsGZDW;
                        this.formData.userAttributeValueText = typeGzdwlx(value);
                        break;
                    case "cMz" :
                        this.columns = columnsMZ;
                        this.formData.userAttributeValueText = typeMz(value);
                        break;
                }
            },
            onUserTypeConfirm: function (item) {
                this.formData.userAttributeValue = item.keyId;
                this.formData.userAttributeValueText = item.text;
                this.showUserType = false;
            },
            validateFormData: function () {
                // 校验规则
                let descriptor;
                let validated;
                let name = this.formData.userAttributeName;
                let type = this.userType;
                if (type != "1") {
                    name = "shxydm";
                }
                switch (name) {
                    case "cUsertype" :
                        descriptor = {cUsertype: userRule};
                        validated = validate(descriptor, {cUsertype: this.postData.cUsertype});
                        break;
                    case "cCardname" :
                        descriptor = {cCardname: new XmRule(true)};
                        validated = validate(descriptor, {cCardname: this.postData.cCardname});
                        break;
                    case "cMz" :
                        descriptor = {cMz: mzRule};
                        validated = validate(descriptor, {cMz: this.postData.cMz});
                        break;
                    case "cZjh" :
                        descriptor = {cZjh: new ZjhmRule(1, true)};
                        validated = validate(descriptor, {cZjh: this.postData.cZjh});
                        break;
                    case "shxydm" :
                        descriptor = {shxydm: new TyshxydmRule(true)};
                        validated = validate(descriptor, {shxydm: this.postData.cZjh});
                        break;
                    case "cEmail" :
                        descriptor = {cEmail: new EmailRule(true)};
                        validated = validate(descriptor, {cEmail: this.postData.cEmail});
                        break;
                    case "cGh" :
                        descriptor = {cGh: zjlxRule};
                        validated = validate(descriptor, {cGh: this.postData.cGh});
                        break;
                    case "cTxdz" :
                        descriptor = {cTxdz: new TxdzRule(1, true)};
                        validated = validate(descriptor, {cTxdz: this.postData.cTxdz});
                        break;
                    case "cDwmc" :
                        descriptor = {cDwmc: new QymcRule(true)};
                        validated = validate(descriptor, {cDwmc: this.postData.cDwmc});
                        break;
                    case "cDwxz" :
                        descriptor = {cDwxz: dwxzRule};
                        validated = validate(descriptor, {cDwxz: this.postData.cDwxz});
                        break;
                    case "cQyfr" :
                        descriptor = {cQyfr: new QyfrRule(3, true)};
                        validated = validate(descriptor, {cQyfr: this.postData.cQyfr});
                        break;
                    case "cDwdz" :
                        descriptor = {cDwdz: new TxdzRule(2, true)};
                        validated = validate(descriptor, {cDwdz: this.postData.cDwdz});
                        break;
                }
                return validated;
            },
        }
    }
</script>

<style lang="less" scoped>
    .edit-personCenter {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .advice-amount {
        margin-top: 10px;
        margin-bottom: 10px;
        text-align: right;

        > span {
            color: #fe4d67;
            font-size: 14px;
            margin-right: 30/2px;
        }
    }
</style>
